export const environment: Environment = {
  name: 'prod',
  apiHost: 'https://cloudwall.aquent.com/api',
  cwHost: 'https://cloudwall.aquent.com',
  macHost: 'https://my.aquent.com/legacy-mac',
  matHost: 'https://my.aquent.com/mat',
  talentAppHost: 'http://talent.aquent.com',
  googleAnalyticsKey: 'UA-24926863-9',
  googleApiKey: 'AIzaSyD4rd125LZYAkV--9coTU7uABBipqAXGBs',
  flags: {
    newRole: true,
    profilePhoto: true,
    positionsCompletedTab: true,
    positionsClosedTab: false,
    timecardsDisputedTab: false,
    invoicePurchaseOrdersTab: false,
    matLogin: true,
    salaryGuide: false,
    aquentsBookPromotion: false,
    debugMenu: false,
    reportsTab: true,
    submittalFeedback: true,
    submittalFeedbackComment: true,
    submittalFeedbackCount: true,
    qccSubmittal: true,
    endOfAssignment: true,
    personaPromotion: true
  }
};
